import { render, staticRenderFns } from "./ProductAcceptanceDialog.vue?vue&type=template&id=4d112f1d"
import script from "./ProductAcceptanceDialog.vue?vue&type=script&lang=js"
export * from "./ProductAcceptanceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports